import { ShiftReport } from "@/pages/shift-report";

export const routeShiftReport = "/mill/shift-report";

export const shiftReportRoutes = [
	{
		path: `${routeShiftReport}`,
		element: <ShiftReport />,
		permission: "ui.navbar.shift.report",
	},
	{
		path: `${routeShiftReport}/:shiftId`,
		element: <ShiftReport />,
		permission: "ui.navbar.shift.report",
	},
];
